import React from 'react';
import {
    ChoiceList,
    Stack,
    TextField,
    Button,
    Select,
} from '@shopify/polaris';
import { CronOptions } from '../../common/Helpers';
class OperationExecutionOptionsPane extends React.Component {

    render() {

        const executionChoices = [
            {
                label: 'Execute Now',
                value: 'now',
                helpText: 'Operation will be created and executed right away.',
            },
            {
                label: 'Execute Manually',
                value: 'manual',
                helpText: 'Operation will be created without being executed. It can be executed manually later.',
            },
            {
                label: 'Execute at Specific Date/Time',
                value: 'dateTime',
                helpText: 'Operation will be created and executed at a specified date/time in the future.',
                renderChildren: this.renderDateTimeOptions
            },
            {
                label: 'Execute Repeatedly',
                value: 'recurring',
                helpText: 'Operation will be created and will execute on a recurring schedule.',
                renderChildren: this.renderRecurringOptions
            },
        ];

        const currentChoice = executionChoices.filter(_ => _.value === this.props.execution.executionChoice)[0];

        return (<div>
            <ChoiceList
                disabled={this.props.disabled}
                choices={executionChoices}
                selected={[this.props.execution.executionChoice]}
                onChange={this.handleChoiceListChange} />
            <Stack distribution="trailing">
                <Button
                    disabled={this.props.disabled}
                    onClick={this.handleExecute}
                    loading={this.props.loading}
                    primary>{currentChoice.label}</Button>
            </Stack>
        </div>);
    }

    renderDateTimeOptions = (isSelected) => {
        if (isSelected) {
            return <TextField
                label="Execution time"
                type="datetime-local"
                onChange={this.handleExecutionTimeChange}
                value={this.props.execution.executionTime}
            />;
        }
    }

    renderRecurringOptions = (isSelected) => {
        if (isSelected) {
            return <Select
                label="Frequency"
                options={CronOptions}
                onChange={this.handleFrequencyChange}
                value={this.props.execution.executionFrequency}
            />;
        }
    }

    handleExecutionTimeChange = (value) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionTime = value;

        this.props.onUpdateExecution(newExecution);
    }

    handleExecute = () => {
        this.props.onExecute(this.props.execution);
    }

    handleFrequencyChange = (value) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionFrequency = value;

        this.props.onUpdateExecution(newExecution);

    }

    handleChoiceListChange = (choice) => {

        let newExecution = JSON.parse(JSON.stringify(this.props.execution));
        newExecution.executionChoice = choice[0];

        this.props.onUpdateExecution(newExecution);
    }

    componentDidMount() {
    }
}

OperationExecutionOptionsPane.defaultProps = {
}

export default OperationExecutionOptionsPane;